import { API } from 'app/services';
import { useAsyncTask, useRouter } from 'app/utils';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ScreeningDetail_Others from './ScreeningDetail_Others';
import ScreeningDetailRegtank from './ScreeningDetailRegtank';

function ScreeningDetail(props) {
  const { routeType = 'account', screenId } = props;
  const access = useSelector((state) => state.profile.access);
  const [runLoadScreening] = useAsyncTask('getScreening');
  const router = useRouter();
  const { match } = router;
  const { params } = match;
  const { enqueueSnackbar } = useSnackbar();

  const screening_id = params.screening_id || screenId;
  const [screeningData, setScreeningData] = useState(null);

  useEffect(() => {
    if (access && access.token) getScreening();
    // eslint-disable-next-line
  }, [access]);
  /**
   * Get the screening details
   * @returns the screening details
   */
  const getScreening = () => {
    if (!screening_id) return enqueueSnackbar('invalid id');
    runLoadScreening(async () => {
      const loader = routeType === 'account' ? API.Screening.get_screen : API.Admin.get_screen;
      const { model } = await loader(screening_id);
      setScreeningData(model);
    });
  };

  if (!screeningData) return null;

  const isRegtank = screeningData.screen_provider_id == 4;

  return isRegtank ? (
    <ScreeningDetailRegtank {...props} screeningData={screeningData} />
  ) : (
    <ScreeningDetail_Others {...props} screeningData={screeningData} />
  );
}

export default ScreeningDetail;
